import '../../assets/css/tailwind.css';

/* Project specific Javascript goes here. */

// Handle alert dismissal
document.addEventListener('DOMContentLoaded', () => {
  const closeButtons = document.querySelectorAll('.btn-close');
  closeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const alert = button.closest('.alert-dismissible');
      if (alert) {
        alert.style.display = 'none';
      }
    });
  });

  // Mobile menu toggle
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const isHidden = mobileMenu.classList.contains('hidden');
      if (isHidden) {
        mobileMenu.classList.remove('hidden');
        menuToggle.setAttribute('aria-expanded', 'true');
      } else {
        mobileMenu.classList.add('hidden');
        menuToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }
});
